import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { General } from 'icons/untitledui';

// components
import Tooltip from 'sidePanel/components/Tooltip';

import { useUser } from 'shared/hooks/api/user';

import * as StyledPanelNav from 'sidePanel/styles/PanelNav.style';
import * as Text from 'theme/components/Text.style';

export default function SettingsTab({
  expanded,
  onOpenSettings,
}: {
  expanded: boolean;
  onOpenSettings: () => void;
}): JSX.Element {
  const { t } = useTranslation('sidePanel');
  const { data: user } = useUser();

  const [showTooltip, setShowTooltip] = useState(false);

  const handlePointerEnter = (e: React.PointerEvent) => {
    if (e.pointerType !== 'mouse') return;
    if (!expanded) {
      setShowTooltip(true);
    }
  };

  const handlePointerLeave = () => {
    setShowTooltip(false);
  };

  return (
    <Tooltip content={t('settings')} visible={showTooltip}>
      <StyledPanelNav.Container
        expanded={expanded}
        isActive={false}
        onClick={onOpenSettings}
        onPointerEnter={handlePointerEnter}
        onPointerLeave={handlePointerLeave}
      >
        <StyledPanelNav.Label>
          <General.Settings01 />

          {expanded && (
            <StyledPanelNav.UserContent>
              <Text.P2Semibold>
                {user.nickname || user.first_name} {user.last_name[0]}.
              </Text.P2Semibold>

              <Text.Label>{user.organization?.name}</Text.Label>
            </StyledPanelNav.UserContent>
          )}
        </StyledPanelNav.Label>
      </StyledPanelNav.Container>
    </Tooltip>
  );
}
